import React from 'react';
import logo from '../../../assets/SchoolLink-logo-web.png';

interface LoginFormProps {
  email: string;
  password: string;
  error: string | null;
  isLoading: boolean;
  onEmailChange: (email: string) => void;
  onPasswordChange: (password: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onForgotPassword: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  email,
  password,
  error,
  isLoading,
  onEmailChange,
  onPasswordChange,
  onSubmit,
  onForgotPassword
}) => {
  return (
    <form method="post" onSubmit={onSubmit}>
      <div className="text-center pb-4">
        <img style={{ width: "70%" }} src={logo} className="rounded" alt="SchoolLink Logo" />
      </div>
      
      {error && (
        <div style={{ color: 'red', fontSize: "14px", marginBottom: "10px" }}>
          {error}
        </div>
      )}
      
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          className="form-control"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          disabled={isLoading}
          required
        />
      </div>
      
      <div className="form-group">
        <label htmlFor="password">Password</label>
        <button
          type="button"
          style={{ float: "right", color: "#398aff", fontSize: "14px", background: "none", border: "none", cursor: "pointer", padding: 0 }}
          onClick={onForgotPassword}
          disabled={isLoading}
        >
          Forgot Password?
        </button>
        <input
          type="password"
          id="password"
          className="form-control"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          disabled={isLoading}
          required
        />
      </div>
      
      <div className="col-12">
        <button
          style={{ marginTop: "20px" }}
          type="submit"
          className="pull-right bg-gradient-theme-left border-0 btn btn-primary btn-lg btn-block"
          disabled={isLoading}
        >
          {isLoading ? 'Logging in...' : 'Login'}
        </button>
      </div>
    </form>
  );
};

export default LoginForm;
